import React from 'react'
import { node, string } from 'prop-types'
import { css } from '@emotion/core'

const cssRibbon = (o) => {
  // options.type is in the following form...
  // 'ribbon-ribbon', 'none-ribbon', 'ribbon-none', 'arrow-ribbon', 'ribbon-arrow', 'none-arrow', 'arrow-none', etc.

  const [left, right] = `${o.type}-`.split('-')

  const cssCenter = css`
    color: ${o.color};
    background-color: ${o.backgroundColor};
    padding: 0 ${o.size};
    font-size: ${o.size};
    height: calc(2 * ${o.size});
    line-height: calc(2 * ${o.size});
    width: max-content;
    position: relative;
    text-align: center;
  `

  const baseCSS = css`
    content: '';
    position: absolute;
    display: block;
    bottom: 0;
  `

  const directionalCSS = (ribbon, arrow, selector, element) => {
    return {
      ribbon: css`
        &:${selector} {
          ${baseCSS};
          border: ${o.size} solid ${o.backgroundColor};
          ${ribbon};
        }
      `,
      arrow: css`
        &:${selector} {
          ${baseCSS};
          border: ${o.size} solid transparent;
          ${arrow};
        }
      `,
      none: css``,
    }[element]
  }

  const leftRibbon = css`
    left: calc(-1.2 * ${o.size});
    border-left-color: transparent;
  `

  const leftArrow = css`
    left: calc(-2 * ${o.size});
    border-right-color: ${o.backgroundColor};
  `

  const rightRibbon = css`
    right: calc(-1.2 * ${o.size});
    border-right-color: transparent;
  `

  const rightArrow = css`
    right: calc(-2 * ${o.size});
    border-left-color: ${o.backgroundColor};
  `

  const cssLeft = directionalCSS(leftRibbon, leftArrow, 'before', left)
  const cssRight = directionalCSS(rightRibbon, rightArrow, 'after', right)

  return [cssLeft, cssCenter, cssRight]
}

export default function TextRibbon({ type, size, color, backgroundColor, children }) {
  const options = {
    type: type || 'ribbon-ribbon',
    size: size || '14px',
    color: color || '#ffffff',
    backgroundColor: backgroundColor || '#000000',
  }
  return <div css={cssRibbon(options)}>{children}</div>
}

TextRibbon.propTypes = {
  type: string,
  size: string,
  color: string,
  backgroundColor: string,
  children: node,
}
